import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../lib/I18n';

const PassengerInfo = ({ className = '', ticket, hideISRN }) => {
    if (
        !ticket ||
        !ticket.passenger ||
        !ticket.passenger.get('name') ||
        !ticket.passenger.get('smartcardNumber')
    ) {
        return null;
    }

    const isChild = ticket && ticket.children > 0;

    return (
        <span className={className}>
            <span>
                <strong>{ticket.passenger.get('name')}</strong>
                {isChild && (
                    <span className="associated-smartcards__child-badge">
                        {` ${t('global.child')} `}
                    </span>
                )}
            </span>
            {!hideISRN &&
                <span>&nbsp;{ticket.passenger.get('smartcardNumber')}</span>
            }
        </span>
    );
};

PassengerInfo.propTypes = {
    ticket: PropTypes.object,
    className: PropTypes.string,
    hideISRN: PropTypes.bool,
};

export default PassengerInfo;
